module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Roman.a137f98.woff2";